// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Ui7JCE","input":"dLA_VV","label":"fx4Lbx","customInput":"s7y7EY","selected":"D0dItB","checkbox":"cPPSDs"};